export const ENABLE_PRESENT_ANNOTATION =
  process.env.REACT_APP_ENABLE_PRESENT_ANNOTATION === "true";

// Opt-in only. Keep off in stage/prod until Automation Preview is ready to ship.
export const ENABLE_AUTOMATION_PREVIEW =
  process.env.REACT_APP_ENABLE_AUTOMATION_PREVIEW === "true";

// Opt-in only. Keep off in stage/prod while Widget Box is being dogfooded.
export const ENABLE_WIDGET_BOX =
  process.env.REACT_APP_ENABLE_WIDGET_BOX === "true";

// Dark-launch the Learning Center until admin preview and staging smoke are complete.
export const ENABLE_LEARNING_CENTER =
  process.env.REACT_APP_ENABLE_LEARNING_CENTER === "true";

// Canva Connect OAuth (browse/create/edit). Public launch is enabled in stage/prod builds.
// Per-account gates still work if a future build explicitly turns this flag off.
export const ENABLE_CANVA_CONNECT_PUBLIC =
  process.env.REACT_APP_ENABLE_CANVA_CONNECT_PUBLIC !== "false";

// Opt-in mobile signup handoff while reminder delivery and War Room reporting are verified.
export const ENABLE_MOBILE_SIGNUP_HANDOFF =
  process.env.REACT_APP_ENABLE_MOBILE_SIGNUP_HANDOFF === "true";

// Admin-only MVP for AI-generated Agenda Box draft content.
export const ENABLE_AI_AGENDA_GENERATOR =
  process.env.REACT_APP_ENABLE_AI_AGENDA_GENERATOR === "true";

// Beta AI-assisted Classes & Schedule Setup. Default off until dogfooding is complete.
export const ENABLE_AI_CLASS_SCHEDULE_SETUP =
  process.env.REACT_APP_ENABLE_AI_CLASS_SCHEDULE_SETUP === "true";

// Screen Templates library. Default off until the library page is ready to ship.
export const ENABLE_SCREEN_TEMPLATES =
  process.env.REACT_APP_ENABLE_SCREEN_TEMPLATES === "true";

// File-based Content Box sharing MVP. Default off until two-account staging QA is complete.
export const ENABLE_CONTENT_BOX_FILE_SHARING =
  process.env.REACT_APP_ENABLE_CONTENT_BOX_FILE_SHARING === "true";
